import { useState, useCallback } from 'react';
import { api } from '../utils/api';

/**
 * useConsentAction — Record a consent/acceptance via POST /api/user/consents.
 *
 * Returns { accept, loading, error, result }.
 * accept() sends the consent record to the backend.
 */
export function useConsentAction() {
  const [state, setState] = useState({ loading: false, error: null, result: null });

  const accept = useCallback(async ({
    contentKey,
    documentId,
    contentVersion,
    acceptanceMechanism,
    typedSignature,
    flow,
    clinicId,
    language,
    countryContext,
    contentType = 'platform_content',
  }) => {
    setState({ loading: true, error: null, result: null });

    try {
      const { data } = await api.post('/user/consents', {
        content_type: contentType,
        content_key: contentKey || null,
        document_id: documentId || null,
        content_version: contentVersion,
        acceptance_mechanism: acceptanceMechanism,
        typed_signature: typedSignature || null,
        flow,
        clinic_id: clinicId || null,
        language: language || 'en',
        country_context: countryContext || null,
      });

      setState({ loading: false, error: null, result: data });
      return data;
    } catch (err) {
      const message = err.response?.data?.detail || err.message || 'Failed to record consent';
      setState({ loading: false, error: message, result: null });
      throw new Error(message);
    }
  }, []);

  return { ...state, accept };
}
